import { render, staticRenderFns } from "./Programa-view.vue?vue&type=template&id=21bd3e3b&scoped=true"
import script from "./Programa-view.vue?vue&type=script&lang=js"
export * from "./Programa-view.vue?vue&type=script&lang=js"
import style0 from "./Programa-view.vue?vue&type=style&index=0&id=21bd3e3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bd3e3b",
  null
  
)

export default component.exports